import React,{useState} from "react";
import { Link ,useHistory , useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import UICheckbox from 'components/checkbox/UICheckbox';
import UIRadio from 'components/radios/UIRadio';
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UITextArea from "components/atoms/textarea/UITextArea";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();
	const [authorInfo, setAuthorInfo] = useState({});
	const [authorId,setAuthorId] = useState('');
	const [authorCode,setAuthorCode] = useState('');
	const [authorNm,setAuthorNm] = useState('');
	const [useYn,setUseYn] = useState('');
	const [authorDc,setAuthorDc] = useState('');
	const [userAuthorYn,setUserAuthorYn] = useState('');
	const [useYnNm,setUseYnNm] = useState('');
	const [userAuthorYnNm,setUserAuthorYnNm] = useState('');
	
	

	function dateLpad(num){
		if(num+''.length == 1){
			num = "0"+num;
		}

		return num;
	}
    
	//상세정보 가지고 오기
	async function initCall(paramAuthorId){
		let param = {
			"AUTHOR_ID": paramAuthorId,
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6432_detail',
			data: param
		})

		const result = response;
		setAuthorInfo(result);

		console.log(JSON.stringify(result));

		setAuthorCode(result.AUTHOR_CODE);
		setAuthorId(result.AUTHOR_ID);
		setAuthorNm(result.AUTHOR_NM);
		setAuthorDc(result.AUTHOR_DC);
		setUserAuthorYn(result.USER_AUTHOR_YN);
		setUseYn(result.USE_YN);

		if(result.USE_YN == "1"){
			setUseYnNm("사용");
		} else{
			setUseYnNm("미사용");
		}


		if(result.USER_AUTHOR_YN == "1"){
			setUserAuthorYnNm("사용");
		} else{
			setUserAuthorYnNm("미사용");
		}
		
	};

	

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(authorInfo).length != 0){
			return authorInfo[name];
		}else{
			return '';
		}
	};


	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './adm6431',  
			state: { data: receivedData }
		});
	}

	//권한 삭제 
	async function authorDelete() {

		let param = {
			"AUTHOR_ID": authorId
		};

		if(await UIUtils.confirm('삭제하시겠습니까?')){
			const response:any = await CommonUtil.execute({
				url:'adm_6432_authorDelete',
				data: param
			})


			if (!response.COMMON_HEAD.ERROR) {
				await UIUtils.alert('삭제 되었습니다.');

				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './adm6431',
					state: { data: receivedData }
				});		
			}
		}  
	}

	//수정 페이지로 이동
	const authorUpdate = function (){
        let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm6434',
		state: { data: receivedData }
		});
	}


	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/common/yesNo", "/common/useYn");

        //넘어온 파라미터 바인딩   
		if(receivedData != undefined){
			let authorId = StringUtil.defaultString(receivedData.vAUTHOR_ID);
			setAuthorId(authorId)
			localStorage.setItem("authorId", authorId);
		}
		
		let authorIdStorage = localStorage.getItem("authorId");
		if (authorIdStorage != null) {
			setAuthorId(authorIdStorage);
		}
		
		
		//상세데이터 가지고 오기
		initCall(authorIdStorage);

		return () => {
		
		}
		
	}, [])//effect

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">권한관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">권한 상세</h1>
						<form className="fo fo-col3" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">권한 코드</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={authorCode} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">권한 이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={authorNm} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사용여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={useYnNm} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">권한 설명</p>
									<div className="fo-value">
										<div className="ta w100p h200 ta-readonly">
										<UITextArea className={'ta-ip'}  value={authorDc} />
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">사용자별 권한관리 여부</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={userAuthorYnNm} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-right hz-gap5">
							<Button color="gray-o" size="sm" onClick={authorDelete} >삭제</Button>
							<Button color="pri-o" size="sm" onClick={authorUpdate}>수정</Button>
							<Button color="gray-o" size="sm" onClick={goList}>목록</Button>
						</div>
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;